import { Component, Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'show-multiple-files-dialog',
    templateUrl: 'show-multiple-files-dialog.component.html',
    styleUrls: ['show-multiple-files-dialog.component.scss']
})
export class ShowMultipleFilesDialog {
    objectKeys = Object.keys;
    currentIndex = 0;
    pageToShow;

    constructor(
        private appService: AppService,
        public dialogRef: MatDialogRef<ShowMultipleFilesDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if (data instanceof Array) {
            data.forEach((page, index) => {
                page.forEach(file => {
                    if (file.show && file.url && file.name) {
                        this.appService.downloadDocument(file.url, file.name).subscribe((res)=>{
                            file.url = URL.createObjectURL(res);
                        })
                    }
                });
                if (this.currentIndex === index) {
                    this.pageToShow = page;
                }
            });
        }
    }

    dismissDialog(){
        this.dialogRef.close();
    }

    showNextFile() {
        this.data.forEach((page, index) => {
            if (index === this.currentIndex + 1) {
                this.pageToShow = page;
            }
        });
        this.currentIndex++;
    }

    showPreviousFile() {
        this.data.forEach((page, index) => {
            if (index === this.currentIndex - 1) {
                this.pageToShow = page;
            }
        });
        this.currentIndex--;
    }
}